import { isValidInsightId } from '@/shared-utilities';

export function initResumableUploadPipelineOnce({
  insightId,
  initializedForInsightIdRef,
  initializeUpload,
}: {
  insightId: string | null;
  initializedForInsightIdRef: React.RefObject<string | null>;
  initializeUpload: () => Promise<void>;
}): void {
  if (!insightId) return;
  if (!isValidInsightId(insightId)) return;
  if (initializedForInsightIdRef.current === insightId) return;
  initializedForInsightIdRef.current = insightId;
  void initializeUpload();
}
